import axios from "./axios";

export function fetchFile(config) {
  return axios({
    method: "get",
    ...config
  });
}

/**
 * 我的作品列表
 * @param  {[type]} config [description]
 * @return {[type]}        [description]
 */
export function fetchMyWorks(config) {
  return axios({
    url: "/member/my-works/index",
    method: "post",
    isToken: true,
    ...config
  });
}

/**
 * 我的作品列表
 * @param  {[type]} config [description]
 * @return {[type]}        [description]
 */
export function fetchUserInfo(config) {
  return axios({
    url: "/member/member/view",
    method: "post",
    isToken: true,
    ...config
  });
}

/**
 * 用户证书列表
 * @param {} config
 */
export function fetchUserCert(config) {
  return axios({
    url: "/activity/cert/member-index",
    method: "POST",
    isToken: true,
    ...config,
    loading: true
  });
}

// 用户报名
export function fetchSignUp(config) {
  return axios({
    url: "/activity/activity/sign",
    method: "POST",
    isToken: true,
    loading: true,
    ...config
  });
}

/**
 * 获取学校列表
 */
export function fetchSchoolList(config) {
  return axios({
    url: "/match/library/index",
    method: "post",
    isToken: true,
    isLoading: true,
    ...config
  });
}
/**
 * 获取院系/专业 通过学校
 * @param {*} config
 * body
 * @param {int} id
 * @returns
 */
export function fetchDepartment(config) {
  return axios({
    url: "/activity/activity/department",
    method: "post",
    isToken: true,
    isLoading: true,
    ...config
  });
}

/**
 * 语林学习拓展数据记录接口
 * @param {*} config
 * @returns
 */
export function fetchExpendViews(config) {
  return axios({
    url: "/expend/views/index",
    method: "post",
    isToken: true,
    isLoading: true,
    ...config
  });
}

/**
 * 上传图片
 * @param {*} config
 * @returns
 */
export function fetchUploadImage(config) {
  return axios({
    url: "/file/images",
    method: "post",
    isToken: true,
    isLoading: false,
    ...config
  });
}
/**
 * 上传视频
 * @param {*} config
 * @returns
 */
export function fetchUploadVideo(config) {
  return axios({
    url: "/file/videos",
    method: "post",
    isToken: true,
    isLoading: false,
    ...config
  });
}

/**
 * 合并上传的文件
 */
export function fetchMergeFile(config) {
  return axios({
    url: "/file/merge",
    method: "post",
    isToken: true,
    ...config
  });
}

export function getKnowingDetail(config) {
  return axios({
    url: "/expend/youzhi/detail",
    method: "post",
    isToken: true,
    ...config
  });
}

// 深度阅读详情
export function fetchDeepReadBookData(config){
  return axios({
    url: "/expend/deepread/detail",
    method: "get",
    isToken: true,
    ...config
  })
}


// WEBPACK FOOTER //
// ./src/request/api_index.js